import type { KeyboardEvent } from 'react'
import { useState } from 'react'
import { getDatePickerKeyboardAction } from './getDatePickerKeyboardAction'

export function useDatePickerOpenState(defaultOpen: boolean, disabled?: boolean, inline?: boolean) {
  const [internalIsOpen, setInternalIsOpen] = useState(defaultOpen)
  const isOpen = inline ? true : internalIsOpen

  const handleOpen = () => {
    if (inline) {
      return
    }

    if (disabled) {
      return
    }

    setInternalIsOpen(true)
  }

  const handleClose = () => {
    if (inline) {
      return
    }

    setInternalIsOpen(false)
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (disabled) {
      return
    }

    const action = getDatePickerKeyboardAction(event.key)
    if (!action) {
      return
    }

    event.preventDefault()

    const handlers = {
      open: handleOpen,
      close: handleClose,
    }

    handlers[action]()
  }

  return {
    isOpen,
    handleOpen,
    handleClose,
    handleKeyDown,
  }
}
